import {Size2D} from '@gongxigames/framework/core/types';

export type ViewportConfig = {
    desktop: Size2D;
    mobile: Size2D;
};
